import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setPostIssueTournament = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_ISSUE_TOURNAMENT
            });
            dispatch(Action.SetGetViewTournament({
                id_tournament: params.id_tournament
            }))
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostIssueTournament as SetPostIssueTournament
}